<template>
    <div>
        <div v-for="task in tasks" :key="task.id" class="px-4 pt-0 mt-1 pb-0 mb-4 rounded-lg bg-white hover:bg-blue-100 border border-white hover:border-gray-200">
            <div class="w-full mb-1 text-lg flex mt-2">
                <div class="flex-1 flex-grow" v-text="task.name"></div>
                <ui-toggle class="inline-block w-auto p-0.5 rounded-xl" field="text-xs"
                           v-model="split.item"
                           :text="`Split Items`"
                           :field="'text-gray-900'"
                ></ui-toggle>
            </div>
            <div v-if="split.item && task.items.length">
                <resource-planning-report-material-items :items="task.items"
                                                         :split="split">
                </resource-planning-report-material-items>
            </div>
            <div class="pb-4" v-else>
                <div v-if="task.materials.length"
                    class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Required
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Requested</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Ordered
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Received</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Still
                        Required
                    </div>
                </div>
                <div
                    class="flex mt-2 p-2 border rounded-lg border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                    v-else-if="task.items.length">
                    No materials for this task
                </div>
                <div
                    class="flex mt-2 p-2 border rounded-lg border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                    v-else>
                    No items for this task
                </div>
                <resource-planning-report-material-item
                    v-for="(material,index) in task.materials" :item="material"
                    :key="index">
                </resource-planning-report-material-item>
            </div>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText, toCurrency, uuid} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import {array} from "i/lib/util";

export default {
    components: {
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        tasks: array,
        split: Object,
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    async mounted() {
    }
};
</script>
